<section class="app-dialog bsc-pin-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="bsc-pin-dialog__icono" aria-hidden="true">
        <span class="material-icons">{{ icono }}</span>
      </span>
      <div>
        <p class="app-dialog__eyebrow">{{ datos.eyebrow }}</p>
        <h2 [id]="idTitulo">{{ datos.titulo }}</h2>
        <p>{{ datos.detalle }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close bsc-pin-dialog__cerrar" aria-label="Cerrar" [disabled]="enviando"
            (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content bsc-pin-dialog__contenido">
    <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
      <mat-label>{{ campoComentario.etiqueta }}</mat-label>
      <textarea matInput [id]="idComentario" rows="3" [maxlength]="largoComentario" [required]="campoComentario.obligatorio"
                [(ngModel)]="comentario" [disabled]="enviando" (ngModelChange)="mensaje = ''"></textarea>
      <mat-hint>{{ campoComentario.ayuda }}</mat-hint>
      <mat-hint align="end">{{ comentario.length }}/{{ largoComentario }}</mat-hint>
    </mat-form-field>

    <output class="bsc-pin-dialog__estado" *ngIf="consultandoPin && !estadoPin">
      <span class="material-icons" aria-hidden="true">hourglass_top</span>
      Revisando tu PIN de autorización…
    </output>

    <div class="bsc-pin-dialog__aviso" *ngIf="sinPin" role="alert">
      <strong>Aún no defines tu PIN de autorización.</strong>
      <p>
        Se define una sola vez en Ajustes, con tu contraseña de COS. Ábrelo en otra pestaña para no perder lo que
        escribiste aquí.
      </p>
      <div class="bsc-pin-dialog__botones">
        <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [href]="rutaAjustes" target="_blank"
           rel="noopener">Abrir Ajustes</a>
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                [disabled]="consultandoPin" (click)="revisarPin()">Ya lo definí</button>
      </div>
    </div>

    <div class="bsc-pin-dialog__aviso is-error" *ngIf="pinBloqueado" role="alert">
      <strong>Tu PIN está bloqueado hasta las {{ pinBloqueado }}.</strong>
      <p>Por cinco intentos fallidos. Espera a esa hora, o pide a quien administra Empleados que lo restablezca.</p>
      <div class="bsc-pin-dialog__botones">
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                [disabled]="consultandoPin" (click)="revisarPin()">Revisar de nuevo</button>
      </div>
    </div>

    <mat-form-field appearance="outline" class="table-page__field bsc-pin-dialog__pin" subscriptSizing="dynamic"
                    *ngIf="!sinPin && !pinBloqueado">
      <mat-label>PIN de autorización</mat-label>
      <input matInput [id]="idPin" type="password" inputmode="numeric" autocomplete="one-time-code" required
             [maxlength]="pinMax" [value]="pin" [disabled]="enviando" (input)="digitos($event)"
             (keydown.enter)="confirmar()" />
      <mat-hint>El tuyo, de {{ pinMin }} a {{ pinMax }} dígitos. {{ avisoIntentos }}</mat-hint>
    </mat-form-field>

    <p class="bsc-pin-dialog__mensaje" role="alert">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="enviando" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="enviando || sinPin || !!pinBloqueado"
            [attr.aria-busy]="enviando" (click)="confirmar()">
      {{ enviando ? "Enviando…" : datos.textoConfirmar }}
    </button>
  </footer>
</section>
